import Vue from 'vue';
import Browse from '@/frontend/components/Studio/Shop/Browse.vue';
import Cart from '@/frontend/components/Studio/Shop/Cart.vue';
import Checkout from '@/frontend/components/Studio/Shop/Checkout.vue';
import ErrorMessages from '@/components/ErrorMessages.vue';
import FeaturedProducts from '@/frontend/components/FeaturedProducts.vue';
import Item from '@/frontend/components/Studio/Shop/Item.vue';
import NewPaintings from '@/frontend/components/NewPaintings.vue';
import NewProducts from '@/frontend/components/NewProducts.vue';
import Pagination from '@/components/Pagination.vue';
import Shop from '@/frontend/components/Studio/Shop/Index.vue';

// Register global Vue components
Vue.component('ErrorMessages', ErrorMessages);
Vue.component('Pagination', Pagination);
Vue.component('NewPaintings', NewPaintings);
Vue.component('NewProducts', NewProducts);
Vue.component('FeaturedProducts', FeaturedProducts);
Vue.component('Shop', Shop);
Vue.component('Browse', Browse);
Vue.component('Item', Item);
Vue.component('Cart', Cart);
Vue.component('Checkout', Checkout);

require('@/app');
